import { html as o, ref as e } from "@microsoft/fast-element";
const a = (s) => {
  const i = o.partial(s.prefix);
  return o`
    <div class="control" part="control">
      <div class="header" ${e("_widgetHeader")}>
        <div class="title">${(t) => t.widgetTitle}</div>
        <div class="header-actions">
          <${i}-button
            size="sm"
            variant="ghost"
            @click="${(t) => t.handleFullSizeButtonClick()}"
          >
            <${i}-icon
              name="${(t) => t.fullSize ? "arrows-pointing-in" : "arrows-pointing-out"}"
              slot="start"
            />
          </${i}-button
          >
          <${i}-button
            size="sm"
            variant="ghost"
            @click="${(t) => t.handleCloseButtonClick()}"
          >
            <${i}-icon name="x-mark" slot="start" />
          </${i}-button>
        </div>
      </div>
      <div class="body" ${e("_widgetBody")}>
        <slot></slot>
      </div>
    </div>
  `;
};
export {
  a as popUpWidgetTemplate
};
